<template>
  <div v-if="data" class="chat-info-container">
    <div class="elements-container">
      <div class="element">
        <span class="title">{{ CONSTANTS.getCopy('CHATINFO_TITLE_CHATBOT') }}</span>
        <span class="content">{{ data.chatbot }}</span>
      </div>
      <div class="element">
        <span class="title">{{ CONSTANTS.getCopy('CHATINFO_TITLE_PLATFORM') }}</span>
        <span class="content">{{ data.platform }}</span>
      </div>
      <div class="element">
        <span class="title">{{ CONSTANTS.getCopy('CHATINFO_TITLE_FIRST_MESSAGE') }}</span>
        <span class="content">{{ data.firstMessage }}</span>
      </div>
      <div class="element">
        <span class="title">{{ CONSTANTS.getCopy('CHATINFO_TITLE_LAST_MESSAGE') }}</span>
        <span class="content">{{ data.lastMessage }}</span>
      </div>
      <div class="element">
        <span class="title">{{ CONSTANTS.getCopy('CHATINFO_TITLE_EXPERIENCE_1') }}
          {{ data.messages }} {{ CONSTANTS.getCopy('CHATINFO_TITLE_EXPERIENCE_2') }}</span>
        <span class="content">
          <ul>
            <li>{{ CONSTANTS.getCopy('CHATINFO_EXPERIENCE_GOOD') }} {{ data.bien }}</li>
            <li>{{ CONSTANTS.getCopy('CHATINFO_EXPERIENCE_WRONG') }} {{ data.mal }}</li>
            <li>{{ CONSTANTS.getCopy('CHATINFO_EXPERIENCE_DOUBT') }} {{ data.duda }}</li>
          </ul>
        </span>
      </div>
      <div class="element">
        <span class="title">{{ CONSTANTS.getCopy('CHATINFO_AGENT_INTERVENTION') }}</span>
        <span class="content">{{ data.agentIntervention ? 'SÍ' : 'NO' }}</span>
      </div>
      <div v-if="data.agentName" class="element">
        <span class="title">{{ CONSTANTS.getCopy('CHATINFO_AGENT_LAST_AGENT') }}</span>
        <span class="content">{{ data.agentName }}</span>
      </div>

      <div v-if="data.agentName" class="element">
        <span class="title">{{ CONSTANTS.getCopy('CHATINFO_AGENT_ACTIVE_NOW') }}</span>
        <span class="content">{{ data.agentMode ? 'SÍ' : 'NO' }}</span>
      </div>
    </div>
    <div class="control-button">
      <button v-if="isBotSelected" class="take-control" @click="toggleAgent(true)">{{ CONSTANTS.getCopy('CHATINFO_BUTTON_TAKE_CONTROL') }}</button>
      <button v-else class="mark-resolved" @click="toggleAgent(false)">{{ CONSTANTS.getCopy('CHATINFO_BUTTON_SOLVED') }}</button>
    </div>
  </div>
</template>

<script>
import CONSTANTS from '../../constants'

export default {
  props: { chatId: Number, isBot: Boolean },
  data () {
    return {
      data: null,
      isBotSelected: this.isBot
    }
  },
  watch: {
    chatId () {
      this.chatId && this.getChatInfo()
    },
    isBot () {
      this.isBotSelected = !this.isBotSelected
      if (!this.chatId) this.data = null
    }
  },
  methods: {
    getChatInfo () {
      this.api.post('/ChatsInfo', { idChat: this.chatId }, false).then(response => {
        this.data = response.chatInfo
      })
    },
    toggleAgent (agent) {
      let message = agent
        ? CONSTANTS.getCopy('CHATINFO_CONFIRM_TAKE_CONVERSATION')
        : CONSTANTS.getCopy('CHATINFO_CONFIRM_RESOLVE_CONVERSATION')
      this.dialog.confirm({ message }).then(() => {
        if (!agent) {
          this.dialog.consultReason().then((response) => {
            this.api.post('/ChatsAgentTakeControl', { agent: 0, idChat: this.chatId, queries: response }).then((res) => {
              this.$emit('toggleAgent', parseInt(this.$route.params.chat))
            })
            this.getChatInfo()
          })
          return
        }
        this.api.post('/ChatsAgentTakeControl', { idChat: this.chatId, agent: 1 }).then((res) => {
          if (res.agentName === null) this.$emit('toggleAgent', parseInt(this.$route.params.chat))
          if (res.agentName !== null) {
            let client = this.$route.params.client
            let message = CONSTANTS.getCopy('CHATINFO_CONVERSATION_TAKEN_MODAL') + ' ' + res.agentName
            let path = client !== undefined ? `/clients/${client}/chats` : '/chats'
            this.dialog.alert({message}).then(() => {
              this.$router.push(path)
              window.location.reload()
            })
          }
        })
        this.getChatInfo()
      }).catch(() => { })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Chats/ChatInfo.vue